import { render, staticRenderFns } from "./CreateDialog.vue?vue&type=template&id=4b6bda28&"
import script from "./CreateDialog.ts?vue&type=script&lang=ts&"
export * from "./CreateDialog.ts?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports